webpackJsonp([6],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _common = __webpack_require__(2);
	
	__webpack_require__(111);
	
	/* eslint-disable */
	var req = __webpack_require__(134);
	req.keys().forEach(function (key) {
		req(key);
	});
	/* eslint-enable */
	
	/* eslint-disable import/first */
	
	/* eslint-enable import/first */
	
	(function () {
		fetch('static/json/cases.json').then(function (response) {
			return response.json();
		}).then(function (json) {
			Array.prototype.forEach.call(json.cases, function (caseVal) {
				document.querySelector('.cases-wrapper').appendChild(document.querySelector('.case-block:first-child').cloneNode(true));
	
				var caseDiv = document.querySelector('.case-block:last-child');
				var caseLink = function () {
					if (caseVal.link === null) {
						return caseVal.website;
					}
	
					if (document.querySelector('.cases-wrapper').getAttribute('data-lang') === 'tw') {
						return caseVal.link;
					}
	
					return '/en' + caseVal.link;
				}();
	
				caseDiv.setAttribute('href', caseLink);
				caseDiv.setAttribute('target', caseVal.link === null ? '_blank' : '_self');
	
				caseDiv.setAttribute('style', 'background-image: url(' + caseVal.thumb + ')');
	
				if (window.screen.width < 480) {
					caseDiv.setAttribute('style', 'background-image: url(' + caseVal.rectThumb + ')');
				}
	
				caseDiv.children[0].innerText = caseVal.brand.substring(0, 1);
				caseDiv.children[1].children[0].innerText = caseVal.brand;
				caseDiv.children[1].children[1].innerText = document.querySelector('.cases-wrapper').getAttribute('data-lang') === 'tw' ? caseVal.desc : caseVal.enDesc;
			});
		});
	})();
	
	window.onload = function () {
		/**
	  * to avoid there is no enough case number
	  * show footer directly
	  */
		if (document.querySelector('.window-section.-space4footer').offsetTop <= window.innerHeight) {
			document.querySelector('.window-section.-footer').classList.add('-bottom');
		}
	
		(0, _common.windowOnLoad)();
	};

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./cases-wrapper.css": 135
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 134;


/***/ }),

/***/ 135:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// project.chunk.js